export const SECURITY_QUESTION_START = 'SECURITY_QUESTION_START';
export const SECURITY_QUESTION_SUCCESS = 'SECURITY_QUESTION_SUCCESS';
export const SECURITY_QUESTION_FAILURE = 'SECURITY_QUESTION_FAILURE';
export const SECURITY_QUESTION_END = 'SECURITY_QUESTION_END';
